import { render, staticRenderFns } from "./MonitBuild.vue?vue&type=template&id=2a4ae7b2&scoped=true&"
import script from "./MonitBuild.vue?vue&type=script&lang=js&"
export * from "./MonitBuild.vue?vue&type=script&lang=js&"
import style0 from "./MonitBuild.vue?vue&type=style&index=0&id=2a4ae7b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ae7b2",
  null
  
)

export default component.exports